<template>
  <el-form label-width="120px" ref="eleBillForm" :rules="eleBillFormRule" :model="eleBillForm" class="step4XiaoHsCom">
    <div>
      <el-tabs :stretch="true" class="cainiaoTab" v-model="activeName">
        <el-tab-pane label="小红书店铺账号授权" name="shop">
          <div class="tab-header">
            <img src="@/assets/images/ecommercepng/icon_dianpu_XIAOHS.png" class="icon-company-box" alt="">
          </div>
          <div class="tab-bottom" v-if="xiaohsShopList.length > 0 || (xiaohsShopList.length <= 0 && loading)">
            <el-form-item label="小红书店铺" prop="shop">
              <div class="y-f">
                <el-select v-model="eleBillForm.shop" placeholder="请选择店铺类型" @change="changeShop">
                  <el-option v-for="item in xiaohsShopList" :key="item.id" :label="item.MallName" :value="item.id">
                  </el-option>
                </el-select>
                <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="storeAuthorization">添加新店铺</span>
              </div>
            </el-form-item>
            <el-form-item label="网点发货地址">
              <div class="y-f" v-if="filterOriginList.length > 0 || loading">
                <el-select v-model="eleBillForm.faceId" placeholder="请选择发货地址">
                  <el-option v-for="item in filterOriginList" :key="item.id" :label="item.addressInfo" :value="item.id">
                  </el-option>
                </el-select>
                <span class="y-ml-10 y-fc-4C84FF y-c-p y-w-100" @click="jumpXiaohs">添加新发货地址</span>
              </div>
              <div class="y-bk-fff6a0" style="padding: 5px" v-else>
                <p class="y-fl-18" style="margin: 0">未找到电子面单发货地址,当前店铺可能未开通电子面单服务或未绑定电子面单帐号。</p>
              </div>
            </el-form-item>
            <div v-if="filterOriginList.length <= 0 && !loading" class="y-fc-4C84FF y-c-p y-f-r y-fs-14">
              <span @click="jumpXiaohs">开通电子面单</span>
              <span @click="storeAuthorization" class="y-ml-10">绑定电子面单账号</span>
              <span @click="howHelpAuth('XIAOHS')" class="y-ml-10">查看教程</span>
            </div>
          </div>
          <div v-else class="tab-bottom y-fs-14 clearfix">
            <p class="y-fc-000 y-fl-18">
              您还未绑定任何小红书店铺，请点击&lt;去绑定&gt;绑定您的小红书店铺，或点击&lt;查看教程&gt;，按步骤进行操作。
            </p>
            <div class="y-fc-4C84FF y-c-p y-f-r">
              <span @click="storeAuthorization">去绑定</span>
              <span @click="howHelpAuth('XIAOHS')" class="y-ml-10">查看教程</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-form>
</template>
<script>
import { getPddMallListApi } from '@/api/customerCode.js';
import { addCustomNewNetBranchApi } from '../../../../api/waybillPrint/customPrint';
export default {
  props: ['currentType', 'userMess', 'isActive', 'saveFaceAccId'],
  model: {
    prop: 'saveFaceAccId',
    event: 'change'
  },
  data() {
    return {
      activeName: 'shop',
      eleBillForm: {
        shop: undefined,
        faceId: '',
        settlementCode: '',
        independentSettlementCode: ''
      },
      eleBillFormRule: {
        shop: [{ required: true, message: '请先授权', trigger: 'change' }],
        faceId: [{ required: true, message: '请选择网点发货地址', trigger: ['blur', 'change']}],
        settlementCode: [{ required: true, message: '请输入客户编号', trigger: 'blur' }],
        independentSettlementCode: [{ required: true, message: '请输入独立客户编码', trigger: 'blur'}]
      },
      loading: true,
      xiaohsShopList: [],
      originList: [],
      filterOriginList: [],
    }
  },
  mounted() {
    this.getPddMallListCopy();
  },
  methods: {
    changeAddress(val) {
      this.$emit('change', val);
    },
    // 选择店铺
    changeShop(){
      // 移除表单的校验效果
      this.$refs['eleBillForm'].clearValidate();
      this.filterOriginList =  [];
      this.originList.forEach(o => {
        if(o.mallId == this.eleBillForm.shop) {
          o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.town || '') + (o.detail || '');
          this.filterOriginList.push(o);
        }
      });
      if(this.filterOriginList.length) {
        this.eleBillForm.faceId = this.filterOriginList[0].id;
        this.$emit('change', this.eleBillForm.faceId);
      } else {
        this.eleBillForm.faceId = '';
        this.$emit('change', '');
      }
    },
    getPddMallListCopy() {
      this.loading = true;
      let params1 = {
        loginId: this.userMess.loginId,
        platform: 'XIAOHS'
      };
      let params2 = {
        cpCode: this.currentType, // 快递公司
        loginId: this.userMess.loginId,
        platformCode: 'XIAOHS',
        billVersion: 2
      }
      let apiList = [getPddMallListApi(params1), addCustomNewNetBranchApi(params2)];
      Promise.all(apiList).then(res => {
        this.xiaohsShopList = res[0].data || [];
        this.eleBillForm.shop = this.xiaohsShopList.length ? this.xiaohsShopList[0].id : '';
        this.originList = res[1].data || [];
        this.filterOriginList =  [];
        this.originList.forEach(o => {
          if(o.mallId == this.eleBillForm.shop) {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.town || '') + (o.detail || '');
            this.filterOriginList.push(o);
          }
        });
        if(this.filterOriginList.length) {
          this.eleBillForm.faceId = this.filterOriginList[0].id;
          this.$emit('change', this.eleBillForm.faceId);
        } else {
          this.eleBillForm.faceId = '';
          this.$emit('change', '');
        }
        this.loading = false;
      }).catch(err => {
        this.$message.error('获取面单账号失败');
        this.loading = false;
      })
    },
    // 弹出帮助窗口
    howHelpAuth(){
      window.open(`https://kh.yto.net.cn/new/helpCenter?typeId=33&problemId=323`, '_blank');
    },
    // 店铺授权
    storeAuthorization() {
      // 小红书电子面单授权 3-xiaohs
      window.open(`https://ark.xiaohongshu.com/ark/authorization?appId=1890113de99742afb66e&redirectUri=${window.location.origin}/steward-api/oauth/callback/xiaohs&state=3-xiaohs`, '_blank');
    },
    jumpXiaohs() {
      // 开通小红书电子面单账号
      window.open('https://ark.xiaohongshu.com/app-order/waybill/apply', '_blank')
    },
  },
  watch: {
    isActive(val) {
      if(!!val) {
        this.getPddMallListCopy();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.step4XiaoHsCom {
  /deep/ .el-tabs__item {
    height: 46px;
    line-height: 46px;
  }
  /deep/ .el-select {
    flex: 1;
  }
  .tab-header {
    display: flex;
    padding: 16px 75px 32px;
    justify-content: center;
  }
  .tab-bottom {
    padding: 0 40px;
  }
}
.icon-company-box {
  width: 35px;
  height: 35px;
}
</style>
